// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { AxiosRequestConfig, AxiosResponse } from "axios";
import { ApiResponse } from "types/models.ts";

import axiosInstance, { PaldockAxiosInstance } from "./axiosInstance.ts";

export class BaseApi {
    protected getAxiosInstance(): PaldockAxiosInstance {
        return axiosInstance;
    }

    protected async get<TResponseData, TData>(
        url: string,
        config?: AxiosRequestConfig & { params?: TData & { filter?: { filter?: { [key: string]: unknown } } } }
    ): Promise<TResponseData> {
        const instance = this.getAxiosInstance();
        const response = await instance.get<TResponseData, AxiosResponse<ApiResponse<TResponseData>>, TData>(
            url,
            config
        );
        return response.data.data;
    }

    protected async getWithStatus<TResponseData, TData>(
        url: string,
        config?: AxiosRequestConfig & { params?: TData & { filter?: { filter?: { [key: string]: unknown } } } }
    ): Promise<{ data: TResponseData; status: number }> {
        const instance = this.getAxiosInstance();
        const response = await instance.get<
            TResponseData,
            AxiosResponse<ApiResponse<TResponseData> | TResponseData>,
            TData
        >(url, config);
        const isWrapped = response.data !== null && typeof response.data === "object" && "data" in response.data;
        const data = isWrapped ? (response.data as ApiResponse<TResponseData>).data : (response.data as TResponseData);
        return { data, status: response.status };
    }

    // TODO - toto pryc. Nejak standartizovat. Nebo mozna upravit get aby to umela vyhodnotit. Ted get pocita s formatem data{}
    protected async getRaw<TResponseData, TData = never>(
        url: string,
        config?: AxiosRequestConfig
    ): Promise<ApiResponse<TResponseData>> {
        const instance = this.getAxiosInstance();
        const response: AxiosResponse<ApiResponse<TResponseData>> = await instance.get<
            TResponseData,
            AxiosResponse<ApiResponse<TResponseData>>,
            TData
        >(url, config);
        return response.data;
    }

    protected async post<TResponseData, TData = never>(
        url: string,
        data?: TData,
        config?: AxiosRequestConfig
    ): Promise<TResponseData> {
        const instance = this.getAxiosInstance();
        const response = await instance.post<TResponseData, AxiosResponse<ApiResponse<TResponseData>>, TData>(
            url,
            data,
            config
        );
        return response.data.data;
    }

    protected async postRaw<TResponseData, TData = never>(
        url: string,
        data?: TData,
        config?: AxiosRequestConfig
    ): Promise<ApiResponse<TResponseData>> {
        const instance = this.getAxiosInstance();
        const response = await instance.post<TResponseData, AxiosResponse<ApiResponse<TResponseData>>, TData>(
            url,
            data,
            config
        );
        return response.data;
    }

    protected async put<TResponseData, TData = never>(
        url: string,
        data?: TData,
        config?: AxiosRequestConfig
    ): Promise<TResponseData> {
        const instance = this.getAxiosInstance();
        const response: AxiosResponse<ApiResponse<TResponseData>> = await instance.put<
            TResponseData,
            AxiosResponse<ApiResponse<TResponseData>>,
            TData
        >(url, data, config);
        return response.data.data;
    }

    protected async putRaw<TResponseData, TData = never>(
        url: string,
        data?: TData,
        config?: AxiosRequestConfig
    ): Promise<ApiResponse<TResponseData>> {
        const instance = this.getAxiosInstance();
        const response: AxiosResponse<ApiResponse<TResponseData>> = await instance.put<
            TResponseData,
            AxiosResponse<ApiResponse<TResponseData>>,
            TData
        >(url, data, config);
        return response.data;
    }

    protected async patch<TResponseData, TData = never>(
        url: string,
        data?: TData,
        config?: AxiosRequestConfig
    ): Promise<TResponseData> {
        const instance = this.getAxiosInstance();
        const response: AxiosResponse<ApiResponse<TResponseData>> = await instance.patch<
            TResponseData,
            AxiosResponse<ApiResponse<TResponseData>>,
            TData
        >(url, data, config);
        return response.data.data;
    }

    protected async patchRaw<TResponseData, TData = never>(
        url: string,
        data?: TData,
        config?: AxiosRequestConfig
    ): Promise<ApiResponse<TResponseData>> {
        const instance = this.getAxiosInstance();
        const response: AxiosResponse<ApiResponse<TResponseData>> = await instance.patch<
            TResponseData,
            AxiosResponse<ApiResponse<TResponseData>>,
            TData
        >(url, data, config);
        return response.data;
    }

    protected async delete<TResponseData, TData = never>(
        url: string,
        config?: AxiosRequestConfig
    ): Promise<TResponseData> {
        const instance = this.getAxiosInstance();
        const response: AxiosResponse<ApiResponse<TResponseData>> = await instance.delete<
            TResponseData,
            AxiosResponse<ApiResponse<TResponseData>>,
            TData
        >(url, config);
        return response.data.data;
    }

    protected async deleteRaw<TResponseData, TData = never>(
        url: string,
        config?: AxiosRequestConfig
    ): Promise<ApiResponse<TResponseData>> {
        const instance = this.getAxiosInstance();
        const response: AxiosResponse<ApiResponse<TResponseData>> = await instance.delete<
            TResponseData,
            AxiosResponse<ApiResponse<TResponseData>>,
            TData
        >(url, config);
        return response.data;
    }
}
